import React, { useState, useEffect } from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Typography,
  Button,
} from "@mui/material";
import styled from "@mui/material/styles/styled";
import { UseScreen } from "../hooks/UseScreen.hook";
import { useDispatch, useSelector } from "react-redux";
import SuccessModal from "../components/SuccessModal";
import { useNavigate } from "react-router-dom";
import { RoomCoste, SoldProducts } from "../components/datatables/index";
import { PrimaryOutlinedButton } from "../theme/index";
import { useParams } from "react-router-dom";
import { editRoomAction } from "../redux/reducers/Edit";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
// import PDFFile from '../components/PDFFile';
import jsPDF from "jspdf";
import {
  collection,
  getDocs,
  addDoc,
  query,
  doc,
  getDoc,
  where,
} from "firebase/firestore";
import db from "../config/firebase";

const Room = styled(Grid)(
  ({ theme }) => `
    :hover{
      cursor: pointer
    }
`
);

const createReservationRoute = "/bookings";

const CheckoutDetail = () => {
  const screenWidth = UseScreen();
  const dispatch = useDispatch();
  const modalStatus = useSelector((state) => state.Modal.modalState);
  const navigate = useNavigate();
  const { room } = useParams();

  const [showModal, setShowModal] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [roomData, setRoomData] = useState({});
  const [estimatedTime, setEstimatedTime] = useState(0);

  useEffect(() => {
    setShowModal(modalStatus);
  }, [modalStatus]);

  useEffect(() => {
    const getReservationInfo = async () => {
      try {
        const q = query(collection(db, "reservation"));
        const querySnapshot = await getDocs(q);
        let reservationArray = [];
        querySnapshot.forEach((doc) => {
          reservationArray.push(doc.data());
        });
        const reservationList = reservationArray.filter(
          (item) => item.roomType == room
        );

        const reservationInfo = reservationList.sort(function (a, b) {
          return new Date(b.checkIn) - new Date(a.checkIn);
        });
        
        // const selectedReservation = reservationInfo.filter(
        //   (item) => {
        //     var compareDate = moment(moment(), "YYYY/MM/DD");
        //     var startDate = moment(item.checkIn, "YYYY/MM/DD");
        //     var endDate = moment(item.checkOut, "YYYY/MM/DD");
            
        //     // omitting the optional third parameter, 'units'
        //     let checkIntoTime = compareDate.isBetween(startDate, endDate); //false in this case

        //     console.log(checkIntoTime);
            
        //     if(checkIntoTime) return item;
        //   }
        // );
        
        let start = moment(reservationInfo[0].checkIn, "YYYY/MM/DD");
        let end = moment(reservationInfo[0].checkOut, "YYYY/MM/DD");
        
        //Difference in number of days
        var momentResult = moment.duration(end.diff(start)).asDays();
        setEstimatedTime(momentResult);
        setUserInfo(reservationInfo[0]);
        getRoomData(reservationInfo[0].roomType);
        return false;
      } catch (err) {
        console.error(err);
        return false;
      }
    };

    const getRoomData = async (roomId) => {
      const docRef = doc(db, "room", `${roomId}`);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setRoomData({ id: docSnap.id, ...docSnap.data() });
      }
    };

    getReservationInfo();
  }, []);

  const tablesTitle = () => {
    return screenWidth <= 500
      ? { fontSize: "1.5rem", fontFamily: "Roboto-Bold" }
      : { fontSize: "2rem", fontFamily: "Roboto-Bold" };
  };

  const closeReservation = () => {
    const changeRoomStatus = (response) => {
      const roomEdited = new FormData();
      const dataNames = [
        "id",
        "roomNumber",
        "category",
        "price",
        "level",
        "status",
        "details",
      ];

      roomEdited.append(dataNames[0], room);
      roomEdited.append(dataNames[1], response.roomNumber);
      roomEdited.append(dataNames[2], response.category);
      roomEdited.append(dataNames[3], response.price);
      roomEdited.append(dataNames[4], response.level);
      roomEdited.append(dataNames[5], "cleaning");
      roomEdited.append(dataNames[6], response.details);
      roomEdited.append("METHOD", "PUT");

      dispatch(editRoomAction(roomEdited, dataNames, room));
      navigate("/dashboard");
    };

    // get room info
    const getRoomInfo = async () => {
      let response;
      const docRef = doc(db, "room", `${room}`);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        response = docSnap.data();
        //console.log("Document data:", docSnap.data());
      }

      changeRoomStatus(response);
    };
    getRoomInfo();

    generatePDF();
  };

  const generatePDF = () => {
    var doc = new jsPDF("p", "pt", "a4");
    doc.html(document.querySelector("#content"), {
      callback: function (pdf) {
        pdf.save(
          `${moment(userInfo.checkIn).format("YYYY/MM/DD")}-${userInfo.name} ${
            userInfo.lastname
          }`
        );
      },
    });
  };

  return (
    <Grid container px={4}>
      <Grid item xs={12}>
        <h2 style={{ fontFamily: "Roboto-Thin" }}>Check-out</h2>
      </Grid>
      {showModal && <SuccessModal view="cleaningRoom" />}

      <Grid container sx={{ mt: 5, justifyContent: "space-between", mb: 2 }}>
        <Grid
          item
          xs={12}
          md={3}
          sx={(theme) => ({
            color: "#000",
            mb: 4,
            border: `1px solid ${theme.palette.primary.main}`,
          })}
          onClick={() => console.log("Go to this reservation checkout")}
        >
          <Typography
            sx={{
              backgroundColor: "primary.light",
              width: "100%",
              my: 0,
              textAlign: "center",
              py: 0.5,
              color: "#FFF",
              fontSize: "1.5rem",
              fontFamily: "Roboto-Bold",
            }}
          >
            Cliente
          </Typography>
          <div style={{ alignItems: "center", padding: "1.5rem 0" }}>
            <Typography
              sx={{
                width: "100%",
                textAlign: "start",
                py: 0.5,
                px: 1,
                color: "#000",
              }}
            >
              Nombre: {userInfo.name ? userInfo.name : ""}{" "}
              {userInfo.lastname ? userInfo.lastname : ""}
            </Typography>
            <Typography
              sx={{
                width: "100%",
                textAlign: "start",
                py: 0.5,
                px: 1,
                color: "#000",
              }}
            >
              Tipo documento: {userInfo.documentType}
            </Typography>
            <Typography
              sx={{
                width: "100%",
                textAlign: "start",
                py: 0.5,
                px: 1,
                color: "#000",
              }}
            >
              Documento: {userInfo.documentNumber}
            </Typography>
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
          sx={(theme) => ({
            color: "#000",
            mb: 4,
            border: `1px solid ${theme.palette.primary.main}`,
          })}
          onClick={() => console.log("Go to this reservation checkout")}
        >
          <Typography
            sx={{
              backgroundColor: "primary.light",
              width: "100%",
              my: 0,
              textAlign: "center",
              py: 0.5,
              color: "#FFF",
              fontSize: "1.5rem",
              fontFamily: "Roboto-Bold",
            }}
          >
            Habitación
          </Typography>
          <div style={{ alignItems: "center", padding: "1.5rem 0" }}>
            <Typography
              sx={{
                width: "100%",
                textAlign: "start",
                py: 0.5,
                px: 1,
                color: "#000",
              }}
            >
              Número habitación: {roomData.roomNumber}
            </Typography>
            <Typography
              sx={{
                width: "100%",
                textAlign: "start",
                py: 0.5,
                px: 1,
                color: "#000",
              }}
            >
              Tipo habitación: {roomData.category}
            </Typography>
            <Typography
              sx={{
                width: "100%",
                textAlign: "start",
                py: 0.5,
                px: 1,
                color: "#000",
              }}
            >
              Costo por día: ${roomData.price}
            </Typography>
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
          sx={(theme) => ({
            color: "#000",
            mb: 4,
            border: `1px solid ${theme.palette.primary.main}`,
          })}
          onClick={() => console.log("Go to this reservation checkout")}
        >
          <Typography
            sx={{
              backgroundColor: "primary.light",
              width: "100%",
              my: 0,
              textAlign: "center",
              py: 0.5,
              color: "#FFF",
              fontSize: "1.5rem",
              fontFamily: "Roboto-Bold",
            }}
          >
            Reserva
          </Typography>
          <div style={{ alignItems: "center", padding: "1.5rem 0" }}>
            <Typography
              sx={{
                width: "100%",
                textAlign: "start",
                py: 0.5,
                px: 1,
                color: "#000",
              }}
            >
              Entrada: {moment(userInfo.checkIn).format("YYYY/MM/DD")}
            </Typography>
            <Typography
              sx={{
                width: "100%",
                textAlign: "start",
                py: 0.5,
                px: 1,
                color: "#000",
              }}
            >
              Salida: {moment(userInfo.checkOut).format("YYYY/MM/DD")}
            </Typography>
            <Typography
              sx={{
                width: "100%",
                textAlign: "start",
                py: 0.5,
                px: 1,
                color: "#000",
              }}
            >
              Tiempo calculado: {estimatedTime}
            </Typography>
          </div>
        </Grid>
      </Grid>

      {/* <Grid item xs={12} sx={ (theme) => ({ backgroundColor: theme.palette.primary.light, color: '#FFF', px: 2, py: 1 }) }>
        <Typography sx={ tablesTitle() }>
            Costo de alojamiento
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <RoomCoste />
      </Grid> */}

      {/* <Grid item xs={12} sx={ (theme) => ({ backgroundColor: theme.palette.primary.light, color: '#FFF', px: 2, py: 1 }) }>
        <Typography sx={ tablesTitle() }>
            Productos vendidos
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <SoldProducts />
      </Grid>
      <Grid item xs={12} sx={{ textAlign: 'end', justifyContent: 'center', my: 5 }}>
        <PrimaryOutlinedButton sx={{ textTransform: 'none', px: 8 }} onClick={ () => closeReservation() }>Terminar e imprimir</PrimaryOutlinedButton>
      </Grid>*/}

      <Grid item xs={12}>
        {/* <PDFFile client={userInfo} room={roomData} /> */}
        <h2 style={{ fontFamily: "Roboto-Thin", marginBottom: "5rem" }}>
          PDF preview
        </h2>

        <div
          id="content"
          style={{
            width: "527px",
            height: "773px",
            padding: "2rem 2rem",
            justifyContent: "center",
            border: "2px solid #000",
          }}
        >
          <div
            style={{
              width: "500px",
              padding: "0 1rem",
              justifyContent: "center",
              textAlign: "end",
            }}
          >
            <small style={{ fontSize: "10px" }}>{moment().format("LL")}</small>
            <br />
            <small style={{ fontSize: "10px" }}>
              #{Math.floor(Math.random() * 100000000)}
            </small>
          </div>

          <div
            style={{
              width: "500px",
              padding: "0 1rem",
              justifyContent: "center",
              textAlign: "center",
              backgroundColor: "#8EDCB9",
              color: "#FFF",
            }}
          >
            <h2>Factura</h2>
          </div>

          <div style={{ display: "flex" }}>
            <div style={{ width: "150px", padding: "0 1rem" }}>
              <h6 style={{ fontSize: "16px" }}>Cliente</h6>
              <small style={{ fontSize: "10px" }}>
                Nombre: {`${userInfo.name} ${userInfo.lastname}`}
                <br />
                Tipo documento: {userInfo.documentType}
                <br />
                Documento: {userInfo.documentNumber}
              </small>
            </div>

            <div style={{ width: "150px", padding: "0 1rem" }}>
              <h6 style={{ fontSize: "16px" }}>Habitación</h6>
              <small style={{ fontSize: "10px" }}>
                Número habitación: {roomData.roomNumber}
                <br />
                Tipo habitación: {roomData.category}
                <br />
                Costo por día: ${roomData.price}
              </small>
            </div>

            <div style={{ width: "150px", padding: "0 1rem" }}>
              <h6 style={{ fontSize: "16px" }}>Reserva</h6>
              <small style={{ fontSize: "10px" }}>
                Entrada: {userInfo.checkIn}
                <br />
                Salida: {userInfo.checkOut}
                <br />
                Tiempo calculado:{" "}
                {moment(userInfo.checkOut).diff(
                  moment(userInfo.checkIn),
                  "days"
                )}{" "}
                día
              </small>
            </div>
          </div>

          <div
            style={{
              width: "500px",
              padding: "3rem 1rem",
              justifyContent: "center",
              textAlign: "end",
            }}
          >
            <small
              style={{
                fontSize: "10px",
                backgroundColor: "#8EDCB9",
                color: "#FFF",
                padding: ".5rem 1rem",
              }}
            >
              Total: ${roomData.price}
            </small>
          </div>
        </div>
        <Grid container>
          <Grid
            item
            xs={12}
            sx={{ textAlign: "end", justifyContent: "center", my: 5 }}
          >
            <PrimaryOutlinedButton
              sx={{ textTransform: "none", px: 8 }}
              onClick={() => closeReservation()}
            >
              Terminar y facturar
            </PrimaryOutlinedButton>
          </Grid>
        </Grid>
        {/* <button type='primary' onClick={ () => generatePDF() }>Generate PDF</button> */}
      </Grid>
    </Grid>
  );
};

export default CheckoutDetail;
